import type { TextProps } from "@chakra-ui/react";
import type { ReactNode } from "react";
import React from "react";
import { Price } from "components/Price";
import { DeprecatedSpinner } from "components/Spinner";
import { ORDER_SUMMARY_CONSTANTS } from "../../OrderSummary.constant";
import {
  Container,
  DeliveryLabel,
  Label,
  OrderSectionLine,
  PriceText
} from "./OrderSections.styles";

const { ESTIMATED_DELIVERY, FREE_DELIVERY } = ORDER_SUMMARY_CONSTANTS;

type Props = {
  section: {
    testId: string;
    label: string | ReactNode;
    color: string;
    variant: string;
    price: number;
    priceStyles?: TextProps;
    customStyles?: {
      display?: string;
      width?: string;
      justifyContent?: string;
      alignItems?: string;
      marginTop?: string;
      fontSize?: string;
    };
    signSymbol?: string;
    hasLine: boolean;
    isDiscount?: boolean;
  };
  display?: boolean;
};

export const OrderSections: React.FC<Props> = ({ section, display = true }) => {
  const {
    testId,
    label,
    color,
    variant,
    price,
    customStyles = {},
    priceStyles = {},
    signSymbol = "",
    hasLine,
    isDiscount = false
  } = section;

  if (!display) return null;

  const showFreeDelivery = label === ESTIMATED_DELIVERY && price === 0;

  return (
    <>
      {hasLine && <OrderSectionLine data-testid="order-section-line" />}
      <Container css={customStyles} data-testid="order-section">
        {typeof label === "string" && (
          <Label
            color={color}
            variant={variant}
            data-testid="order-summary-label"
          >
            {label}
          </Label>
        )}

        {typeof label !== "string" && <>{label}</>}

        {showFreeDelivery && (
          <DeliveryLabel color={color} variant={variant} data-testid={testId}>
            {FREE_DELIVERY}
          </DeliveryLabel>
        )}

        {price === -1 ? (
          <DeprecatedSpinner />
        ) : (
          !showFreeDelivery && (
            <PriceText data-testid={testId}>
              <Price
                price={price}
                signSymbol={signSymbol}
                variant={variant}
                color="black"
                as="span"
                isDiscount={isDiscount}
                {...priceStyles}
              />
            </PriceText>
          )
        )}
      </Container>
    </>
  );
};
